import moment from 'moment';
import TrashIcon from '../../../assets/img/button-icons/trash-red.svg';

export function managerUserNamesFormatter(cell, row) {
  if ((cell, row)) {
    return (
      <>
        <div>{row.first_name + ' ' + row.last_name}</div>
        {row.clinician_id ? <div>{row.clinician_id}</div> : null}
      </>
    );
  }
}

export function managerUserSinceFormatter(cell, row) {
  if ((cell, row)) {
    return (
      <>
        <div>{moment(cell).format('DD MMM YY')}</div>
      </>
    );
  }
}

export function managerUserDeleteFormatter(cell, row) {
  if ((cell, row)) {
    return (
      <>
        <button className="medication-button" type="button">
          <img src={TrashIcon} alt="delete user" id={row.id} />
        </button>
      </>
    );
  }
}

export const manageMedicationDeleteFormatter = (
  cell,
  row,
  onDeleteClick,
  disabled,
) => {
  if ((cell, row)) {
    return (
      <>
        <button
          className="medication-button"
          type="button"
          onClick={onDeleteClick}
          disabled={disabled}
        >
          <img src={TrashIcon} alt="delete-medication" id={row.id} />
        </button>
      </>
    );
  }
};

export function manageEditFormatter(cell, row) {
  if ((cell, row)) {
    return (
      <>
        <button type="button">
          <i className="fa-solid fa-pen fa-md" />
        </button>
      </>
    );
  }
}

export function managerUserCheckboxFormatter(
  cell,
  row,
  rowIndex,
  formatExtraData,
) {
  if ((cell, row)) {
    const onToggle = formatExtraData?.onToggle;
    return (
      <>
        <div className="form-check text-center content-center">
          <input
            className="form-check-input form-check-input-border"
            type="checkbox"
            checked={!!cell}
            onChange={() => {
              if (typeof onToggle === 'function') {
                onToggle(rowIndex);
              }
            }}
          />
        </div>
      </>
    );
  }
}

export function disabledCheckboxFormatter(cell, row) {
  if ((cell, row)) {
    return (
      <>
        <div className="form-check text-center content-center">
          <input
            className="form-check-input form-check-input-border"
            type="checkbox"
            checked={cell}
            disabled
            onChange={(value) => {}} // do nothing, just to avoid React warning
          />
        </div>
      </>
    );
  }
}

export function managerUserClinicHeaderFormatter(column, index, middleIndex) {
  return (
    <div className="h-100 d-flex flex-column justify-content-between pb-2">
      {index === middleIndex ? (
        <div className="text-nowrap overflow-visible">
          <b>Sites</b>
        </div>
      ) : (
        <div className="header-placeholder" />
      )}
      <div>{column.text}</div>
    </div>
  );
}

export function managerUserRoleHeaderFormatter(column, index, middleIndex) {
  return (
    <div className="h-100 d-flex flex-column justify-content-between pb-2">
      {index === middleIndex ? (
        <div className="text-nowrap overflow-visible">
          <b>Roles</b>
        </div>
      ) : (
        <div className="header-placeholder" />
      )}
      <div>{column.text}</div>
    </div>
  );
}

export function managerTaskTeamHeaderFormatter(column, index, middleIndex) {
  return (
    <div className="h-100 d-flex flex-column justify-content-between pb-2">
      {index === middleIndex ? (
        <div className="text-nowrap overflow-visible">
          <b>My teams</b>
        </div>
      ) : (
        <div className="header-placeholder" />
      )}
      <div>{column.text}</div>
    </div>
  );
}

export const calculateMiddleIndex = (amount) => {
  if (!amount || amount < 1) {
    return 0;
  }
  return Math.floor((amount - 1) / 2);
};
